import { render, staticRenderFns } from "./Licheng.vue?vue&type=template&id=a6b4e9b6&scoped=true&"
import script from "./Licheng.vue?vue&type=script&lang=js&"
export * from "./Licheng.vue?vue&type=script&lang=js&"
import style0 from "./Licheng.vue?vue&type=style&index=0&id=a6b4e9b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b4e9b6",
  null
  
)

export default component.exports